import { useCallback, useEffect, useState } from "react";
import { FeedbackForm, Modal } from "@medbillai/ui";
import { Flag } from "@medbillai/utils";
import { analyticsService } from "../../../lib/analytics";
import { useBoolVariation } from "../../../lib/flag";
import { useSignUpOnboardingStore } from "../../../lib/sign-up-onboarding/signUpOnboardingStore";
import { REFERRAL_SOURCE_OPTIONS } from "./ReferralSourceOptions";
const OTHER = "Other";
export function ReferralModal() {
  const showModalFlag = useBoolVariation(Flag.SHOW_POST_ONBOARDING_REFERRAL_MODAL, false);
  const shouldShowReferralModal = useSignUpOnboardingStore(state => state.shouldShowReferralModal);
  const setShouldShowReferralModal = useSignUpOnboardingStore(state => state.setShouldShowReferralModal);
  const [showModal, setShowModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [moreDetailsText, setMoreDetailsText] = useState<string | undefined>(undefined);
  const showMoreDetails = moreDetailsText !== undefined;
  useEffect(() => {
    if (shouldShowReferralModal && showModalFlag) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [shouldShowReferralModal, showModalFlag]);
  const fireAnalytics = useCallback((options: string[], moreDetails?: string) => {
    analyticsService.trackEvent("PostOnboardingReferralSource", {
      sources: options,
      ...(moreDetails && {
        moreDetails
      })
    });
  }, []);
  const handleSubmit = useCallback(() => {
    const hasOther = selectedOptions.includes(OTHER);
    if (hasOther && !showMoreDetails) {
      // Transition to more details screen
      setMoreDetailsText("");
    } else {
      // Fire analytics, reset state, and close
      fireAnalytics(selectedOptions, showMoreDetails ? moreDetailsText : undefined);
      setSelectedOptions([]);
      setMoreDetailsText(undefined);
      setShowModal(false);
      setShouldShowReferralModal(false);
    }
  }, [selectedOptions, showMoreDetails, moreDetailsText, fireAnalytics, setShouldShowReferralModal]);
  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) {
      // If dismissing without having submitted, capture whatever options we have
      if (selectedOptions.length > 0) {
        fireAnalytics(selectedOptions);
      }
      // Reset state
      setSelectedOptions([]);
      setMoreDetailsText(undefined);
      setShowModal(false);
      setShouldShowReferralModal(false);
    }
  }, [selectedOptions, fireAnalytics, setShouldShowReferralModal]);
  const headerTitle = showMoreDetails ? "Any other details?" : "How did you hear about Granted?";
  const headerSubtitle = showMoreDetails ? "Your feedback helps us improve our reach." : "We'd love to know how you discovered us. This helps us improve our reach.";
  return <Modal open={showModal} onOpenChange={handleOpenChange} size="small" headerProps={{
    title: headerTitle,
    subtitle: headerSubtitle,
    variant: "largeTitle"
  }} footerProps={{
    primaryButtonProps: {
      children: "Submit",
      disabled: selectedOptions.length === 0,
      onPress: handleSubmit
    }
  }} data-sentry-element="Modal" data-sentry-component="ReferralModal" data-sentry-source-file="ReferralModal.tsx">
      <FeedbackForm options={REFERRAL_SOURCE_OPTIONS} selectedOptions={selectedOptions} onSelectedOptionsChange={setSelectedOptions} moreDetailsPlaceholder="How did you hear about us? Any other details?" moreDetailsText={moreDetailsText} onMoreDetailsTextChange={setMoreDetailsText} data-sentry-element="FeedbackForm" data-sentry-source-file="ReferralModal.tsx" />
    </Modal>;
}